import restful, { fetchBackend } from 'restful.js';

import { setLoading } from './actions/loading';
import { setArtisan } from './actions/auth';
import collections from './constants/collections';
import store from './store';

const api = restful(
  `${window.location.origin}/api`,
  fetchBackend((...args) => window.fetch(...args))
);

api.login = api.custom(collections.login);
api.devis = api.all(collections.devis);
api.interventions = api.all(collections.interventions);
api.services = api.all(collections.services);
api.artisans = api.all(collections.artisans);
api.campagnes = api.all(collections.campagnes);
api.signature = api.custom(collections.signature);
api.paiements = api.all(collections.paiements);
api.propositions = api.all(collections.propositions);
api.metiersDevis = api.all(collections.metiersDevis);
api.count = api.all(collections.count)
api.dropbox = api.custom('dropbox');
api.combinations = api.custom('combinations');

const logRequest = ['login', 'verifToken'];
const dropboxIaRequest = ['/dropbox/photo/artisans', '/dropbox/certificat'];
/**
 * event action for api call
 * @param {String} event - event name
 * 'request' => before api call
 * 'response' => after api call successful
 * 'error' => after error
 * @param {Object} config - request config (method, data ...)
 */
let timeoutId;
const responsesArr = [];

api.addRequestInterceptor((request) => {
  const { headers, ...config } = request;
  const timestamp = new Date().getTime();
  let message = '';
  if (logRequest.some(e => config.url.includes(e))) {
    message = 'Connexion en cours veuillez patienter';
  }
  else if (dropboxIaRequest.some(e => config.url.includes(e))) {
    message = '🤖 Analyse IA du certificat en cours...';
  }
  timeoutId = setTimeout(() =>
    store.dispatch(
      setLoading({
        open: true,
        message
      })
    ));
  responsesArr.push({ timestamp, timeoutId, ...config });
  return {
    ...config,
    headers: { ...headers, timeoutId, timestamp }
  };
});

api.on('response', (t) => {
  const headers = t.headers();
  const index = responsesArr.findIndex(e =>
    e.timestamp === Number(headers.timestamp) &&
  e.timeoutId === Number(headers.timeoutid)
  );
  if (index > -1) {
    clearTimeout(responsesArr[index].timeoutId);
    responsesArr.splice(index, 1);
  } else {
    clearTimeout(responsesArr[responsesArr.length - 1].timeoutId);
    responsesArr.pop();
  }
  if (!responsesArr.length) {
    store.dispatch(setLoading({ open: false }));
  }
});

api.on('error', (error) => {
  responsesArr.map(e => clearTimeout(e.timeoutId));
  responsesArr.pop();
  store.dispatch(setLoading({ open: false }));
  const errorCode = error && error.response && error.response.data
    && error.response.data.error;
  if (errorCode === 'ACCESS_GATE_BLOCKED') {
    setArtisan();
  }
});

api.subscribe = (store) => {
  store.subscribe(() => {
    const state = store.getState();
    api.header('Authorization', state.token);
  });
};

export default api;
